<template>
  <div class="app-search d-none d-lg-inline-block">
    <div
      class="position-relative"
      v-bind:class="{ 'focused is-focused': focused, 'is-filled': searchQuery  }"
    >
      <input
        type="text"
        class="form-control"
        placeholder="Procurar por uma tarefa..."
        @focus="focused=!focused"
        @blur="clearSearch"
        @input="filterItems"
        v-model="searchQuery"
      />
      <span class="bx bx-search-alt"></span>
    </div>
    <ul v-if="searchQuery.length >= 3" class="list-group">
      <li
        class="list-group-item"
        v-for="item in filteredItems"
        :key="item.id"
        @click="setItem(item.bucket_id, item.id)"
      >
      <div class="bucket-named"> {{ item.bucket_name }}</div>
      {{ item.name | limited(100)}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    label: { type: String, required: false, default: "" },
    data: { type: [Array, Object], required: false, default: () => [] }
  },
  data() {
    return {
      focused: false,
      valueDefault: "",
      searchQuery: "",
      filteredItems: [],
      items: [],
    };
  },
  watch: {
    data: {
      handler(newData) {
        if (newData.length) {
          this.setTitles();
        }
      },
      immediate: true
    }
  },
  methods: {
    setTitles() {
      let result = [];
      this.data.forEach(element => {
        element.tasks.forEach(task => {
          let t = {
            id: task.id,
            bucket_id: task.bucket_id,
            bucket_name: element.name,
            name: task.name
          };
          result.push(t);
        });
        element.taskCompletes.forEach(complete => {
          let t = {
            id: complete.id,
            bucket_id: complete.bucket_id,
            bucket_name: element.name,
            name: complete.name
          };
          result.push(t);
        });
      });
      this.items = result;
    },
    filterItems() {
      const query = this.searchQuery.toLowerCase();
      this.filteredItems = this.items.filter(item =>
        item.name.toLowerCase().includes(query)
      );
    },
    clearSearch() {
      this.focused = !this.focused;
      const _that = this;
      setTimeout(() => {
          _that.searchQuery = "";
          _that.filteredItems = [];
      }, 1000);
    },
    setItem(bucket_id, id) {
      this.focused = !this.focused;
      this.$emit("openForm", bucket_id, id);
    }
  }
};
</script>
<style scoped>
.search-box {
  position: relative;
  float: left;
  width: 100%;
}
.list-group {
  position: absolute;
  float: left;
  right: 11px;
  top: 44px;
  width: 300px;
  height: auto;
  max-height: 300px;
  border: none;
  background: none;
  border-top: none;
  list-style: none;
  z-index: 9999;
  overflow: auto;
  box-shadow: 0 .2rem 2rem rgba(0,0,0,.3);
  border-top-color: transparent !important;
}
.list-group > :last-child {
  -webkit-border-bottom-right-radius: 0.5rem;
  -webkit-border-bottom-left-radius: 0.5rem;
  -moz-border-radius-bottomright: 0.5rem;
  -moz-border-radius-bottomleft: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background: #f8f9fa;
  border-top: 1px solid rgba(187, 187, 187, .2);
  color: #8687a4;
  font-size: 12px;
  height: auto;
}
.list-group-item > .bucket-named{
    font-size: 10px;
}
.list-group-item:hover {
  background: rgb(255, 255, 255) !important;
  color: #000 !important;
  cursor: pointer;
}
.list-group-item:hover  > .bucket-named{
    color: #8687a4 !important;
}
.form-control::placeholder{
    color: rgba(255, 255, 255, .5);
}
</style>